/* eslint-disable @typescript-eslint/naming-convention */
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LaunchScreenComponent } from '../components/launch-screen/launch-screen.component';
import { TranslateModule } from '@ngx-translate/core';
import { SessionExpiredComponent } from '../components/session-expired-model/session-expired-model.component';
import { MaterialModule } from '../core/material_modules/material.module';
import { DateTimePipe } from '../core/pipes/datetimeformator.pipe';
import { DateFormatPipe } from '../core/pipes/dateFormat.pipe';
import { CurrencyFormatPipe } from'../core/pipes/currency.pipe';
import { MyCustomPaginatorIntl } from '../core/services/paginator_service/my-paginator.service';
import { CreateNewQuickFilterComponent, QuickFilterComponent } from '../components/quick-filter/quick-filter.component';
import { GenerateOrListFilterComponent } from '../components/quick-filter/generate-or-list-filter/generate-or-list-filter.component';
import { DateAgoPipe } from '../core/pipes/dateago.pipe';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgxMatTimepickerModule, NgxMatDatetimePickerModule, NgxMatNativeDateModule, NgxMatDateAdapter } from '@angular-material-components/datetime-picker';
import { NGX_MAT_DATE_FORMATS } from '@angular-material-components/datetime-picker';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { NgxMatMomentModule, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular-material-components/moment-adapter';
import { TimeFormatPipe } from '../core/pipes/timeFormat.pipe';
import { CustomNgxDatetimeAdapter } from '../core/services/utility_functions/CustomNgxDatetimeAdapter';
import { MY_FORMATS } from '../core/services/utility_functions/date_format';
import { SafeHtml } from '../core/pipes/safeHTML.pipe';
import { EmployeeTooltipComponent } from '../components/tooltip/employee-tooltip/employee-tooltip.component';
import { GoogleMapsAutocompleteDirective } from '../directives/google-maps-autocomplete.directive';
import { APILazyLoadingDirective } from '../directives/api_lazy_loading.directive';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { TextEditorComponent } from '../components/text-editor/text-editor.component';
import { TextEditorService } from '../components/text-editor/text-editor.service';
import { BadgeComponent } from '../components/badge/badge.component';
import { SnackBarComponent, SnackBarService } from '../components/snackbar/snackbar.component.service';
import { provideHotToastConfig } from '@ngneat/hot-toast';
import { NgxTippyModule } from 'ngx-tippy-wrapper';
import { ZuperDialogModule } from '@zuper/components/zuper-dialog';
import { RouterModule } from '@angular/router';
import { LazyLoaderComponent } from '../components/lazy-loader/lazy-loader.component';
import { CustomerTooltipComponent } from '../components/tooltip/customer-tooltip/customer-tooltip.component';
import { DatePickerFormatDirective } from '../directives/date-picker-format.directives';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { FileUploadModule } from 'ng2-file-upload';
import { ModuleSummaryComponent } from '../components/module-summary/module-summary.component';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { ZuperDateRangeComponent } from '../components/zuper-daterange/zuper-daterange.component';
import { JobCardComponent } from '../components/job-card/job-card.component';
import { AttachmentsListComponent } from '../components/attachments-list/attachments-list.component';
import { UpdateFieldComponent } from '../components/update-field/update-field.component';
import { DecimalValidatorDirective } from '../directives/decimal-validator.directive';
import { UpdateStatusComponent } from '../components/update-status/update-status.component';
import { SendEmailSmsComponent } from '../components/send-email-sms/send-email-sms.component';
import { NgOptionHighlightModule } from '@ng-select/ng-option-highlight';
import { LocalStorageService } from '../core/services/localstorage.service';
import { AngularSplitModule } from 'angular-split';
import { LightgalleryModule } from 'lightgallery/angular';
import { CustomersListComponent } from '../components/customers-list/customers-list.component';
import { JobsListComponent } from '../components/jobs-list/jobs-list.component';
import { SaveFilterComponent } from '../components/datagrid/save-filter.component';
import { PaymentSettingsComponent } from '../components/payment-settings/payment-settings.component';
import { GalleryDetailsComponent } from '../components/gallery-details/gallery-details.component';
import { LocationPreviewComponent } from '../components/location-preview/location-preview.component';
import { UpdateJobStatusComponent } from '../components/job-status/job-status.component';
import { EmployeeAssignedTooltipComponent } from '../components/tooltip/employee-assigned-tooltip/employee-assigned-tooltip.component';
import { UpdateScheduleComponent } from '../components/update-schedule/update-schedule.component';
import { NgOtpInputModule } from  'ng-otp-input';
import { CustomFieldsComponent } from 'app/components/custom-fields/custom-fields.component';
import { MenuTooltipComponent } from 'app/components/tooltip/menu-tooltip/menu-tooltip.component';
import { DateRangeModule } from 'app/components/date-range/date-range.module';
import { DialogWithMessageRemarksComponent } from 'app/components/dialog-with-message-and-remarks/dialog-with-message-and-remarks.component';
import { ShimmerModule } from 'app/components/shimmer/shimmer.module';
import { ProductDetailsModelComponent } from 'app/components/product-details/product-details.model.component';
import { TagsComponent } from 'app/components/tags/tags.component';
import { AssistedSchedulerModule } from 'app/components/assisted-scheduler/assisted-scheduler.module';
import { ViewAllRecurringJobsComponent } from '../components/view-all-recurring-jobs/view-all-recurring-jobs.component';
import { InvoiceStatementComponent } from '../components/invoice-statement/invoice-statement.component';
import { AssignEmployeeTooltipComponent } from 'app/modules/jobs/assign-tooltip/assign-tooltip.component';
import { PrintOrShareAsPDFComponent } from 'app/components/print-share-pdf/print-share-pdf.component';
import { UpdatePriorityComponent } from 'app/components/update-priority/update-priority.component';
import { RequestCardComponent } from 'app/components/request-card/request-card.component';
import { ZuperShimmerLoadingModule } from '../components/zuper-shimmer-loading/zuper-shimmer-loading.module';
import { ZuperDrawerModule } from '@zuper/components/zuper-drawer';
import { ZuperCardModule } from '@zuper/components/zuper-card';
import { ZuperAlertModule } from '@zuper/components/zuper-alert';
import { RestrictNumberDecimalDirective } from 'app/directives/number-decimal-restrict.directive';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { AdvanceFilterComponent } from 'app/components/quick-filter/advance-filter/advance-filter.component';
import { AutocompleteOffDirective } from 'app/directives/auto-complete-off.directive';
import { ProjectCardComponent } from 'app/components/project-card/project-card.component';
import { TabsComponent } from 'app/components/tabs/tabs.component';
import { ProjectsListComponent } from 'app/components/projects-list/projects-list.component';
import { UpdateProjectStatusComponent } from 'app/components/project-status/project-status.component';
import { HasPropertyPipe } from 'app/core/pipes/hasProperty.pipe';
import { CreatedPopupComponent } from 'app/components/created-popup/created-popup.component';
import { PdfRendererComponent } from 'app/components/pdf-renderer/pdf-renderer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { PdfRendererWrapperComponent } from 'app/components/pdf-renderer-wrapper/pdf-renderer-wrapper.component';
import { DialogWithConfirmationComponent } from 'app/components/dialog-with-confirmation/dialog-with-confirmation.component';
import { TagsModule } from 'app/components/tags/tags.module';
import { ScrollRestrictDirective } from 'app/directives/scroll-restrict.directive';
import { MenuTriggerOnKeydownDirective }from 'app/directives/menu-trigger-down.directive';
import { ProductAssociationComponent } from 'app/components/product-association/product-association.component';
import { NgEventBus } from 'ng-event-bus';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { ZuperStackedToastComponent } from 'app/components/zuper-stacked-toast/zuper-stacked-toast.component';
import { RecurrenceRuleComponent } from 'app/components/recurrence-rule/recurrence-rule.component';
import { JobServiceTerritoryToolTipComponent } from 'app/modules/jobs/job-details/job-service-territory-tooltip/job-service-territory-tooltip.component';
import { PPMDetailsComponent } from 'app/modules/assets/ppm-details/ppm-details.component';
import { ProfileSettingsComponent } from 'app/components/profile-settings/profile-settings.component';
import { UserSelectionComboBoxComponent } from '../../../projects/settings/src/app/components/communications/user-selection-combo-box/user-selection-combo-box.component';
import { PhoneNumberPipe } from 'app/core/pipes/phoneNumber.pipe';
import { ProductSubscriptionAlertComponent } from 'app/components/product-subscription-alert/product-subscription-alert.component';
import { DurationPipe } from 'app/core/pipes/duration.pipe';
import { RequestsListComponent } from 'app/components/requests-list/requests-list.component';
import { TextEditorModule } from 'app/components/text-editor/text-editor.module';
import { InfinityScrollDirective } from 'app/directives/infinity-scroll.directive';
import { NumberDirective } from 'app/directives/number-only-directive';
import { UnreadCountPipe } from 'app/core/pipes/unreadCount.pipe';
import { BrnSelectModule } from '@spartan-ng/ui-select-brain';
import { HlmSelectModule } from '@spartan-ng/ui-select-helm';
import { FilePlaceholderModule } from 'app/components/file-placeholder/file-placeholder.module';
import { TimezoneChangedPopupComponent } from 'app/components/timezone-changed-popup/timezone-changed-popup.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        TranslateModule,
        MaterialModule,
        NgSelectModule,
        NgOptionHighlightModule,
        NgxMatTimepickerModule,
        NgxMatDatetimePickerModule,
        NgxMatNativeDateModule,
        NgxMatMomentModule,
        NgxTippyModule,
        RouterModule,
        ZuperDialogModule,
        FileUploadModule,
        ZuperShimmerLoadingModule,
        NgxDaterangepickerMd.forRoot(),
        AngularSplitModule,
        LightgalleryModule,
        NgOtpInputModule,
        DateRangeModule,
        AssistedSchedulerModule,
        ShimmerModule,
        ZuperDrawerModule,
        ZuperCardModule,
        ZuperAlertModule,
        PdfViewerModule,
        CarouselModule,
        BrnSelectModule,
        HlmSelectModule,
        TagsModule,
        TextEditorModule,
        FilePlaceholderModule
    ],
    exports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LaunchScreenComponent,
        SessionExpiredComponent,
        TranslateModule,
        MaterialModule,
        NgSelectModule,
        NgOptionHighlightModule,
        DateTimePipe,
        DateFormatPipe,
        DateAgoPipe,
        TimeFormatPipe,
        CurrencyFormatPipe,
        HasPropertyPipe,
        SafeHtml,
        QuickFilterComponent,
        CreateNewQuickFilterComponent,
        GenerateOrListFilterComponent,
        NgxMatTimepickerModule,
        NgxMatDatetimePickerModule,
        NgxMatNativeDateModule,
        NgxMatMomentModule,
        EmployeeTooltipComponent,
        SaveFilterComponent,
        BadgeComponent,
        GoogleMapsAutocompleteDirective,
        APILazyLoadingDirective,
        SnackBarComponent,
        NgxTippyModule,
        RouterModule,
        ZuperDialogModule,
        LazyLoaderComponent,
        CustomerTooltipComponent,
        DatePickerFormatDirective,
        FileUploadModule,
        ModuleSummaryComponent,
        NgxDaterangepickerMd,
        ZuperDateRangeComponent,
        JobCardComponent,
        AttachmentsListComponent,
        UpdateFieldComponent,
        DecimalValidatorDirective,
        UpdateStatusComponent,
        SendEmailSmsComponent,
        ZuperShimmerLoadingModule,
        AngularSplitModule,
        LightgalleryModule,
        CustomersListComponent,
        RequestsListComponent,
        JobsListComponent,
        PaymentSettingsComponent,
        GalleryDetailsComponent,
        LocationPreviewComponent,
        TitleCasePipe,
        UpdateJobStatusComponent,
        EmployeeAssignedTooltipComponent,
        UpdateScheduleComponent,
        DatePipe,
        NgOtpInputModule,
        CustomFieldsComponent,
        MenuTooltipComponent,
        DateRangeModule,
        AssistedSchedulerModule,
        DialogWithMessageRemarksComponent,
        ShimmerModule,
        ProductDetailsModelComponent,
        TagsModule,
        TextEditorModule,
        ViewAllRecurringJobsComponent,
        InvoiceStatementComponent,
        AssignEmployeeTooltipComponent,
        RequestCardComponent,
        ZuperDrawerModule,
        ZuperCardModule,
        ZuperAlertModule,
        RestrictNumberDecimalDirective,
        AdvanceFilterComponent,
        ProjectCardComponent,
        TabsComponent,
        ProjectsListComponent,
        UpdateProjectStatusComponent,
        CreatedPopupComponent,
        PdfRendererComponent,
        PdfViewerModule,
        PdfRendererWrapperComponent,
        DialogWithConfirmationComponent,
        ProductAssociationComponent,
        CarouselModule,
        ZuperStackedToastComponent,
        JobServiceTerritoryToolTipComponent,
        ScrollRestrictDirective,
        MenuTriggerOnKeydownDirective,
        RecurrenceRuleComponent,
        JobServiceTerritoryToolTipComponent,
        ProfileSettingsComponent,
        UserSelectionComboBoxComponent,
        PhoneNumberPipe,
        PPMDetailsComponent,
        ProfileSettingsComponent,
        InfinityScrollDirective,
        NumberDirective,
        DurationPipe,
        UnreadCountPipe,
        FilePlaceholderModule
    ],
    declarations: [
        ZuperDateRangeComponent,
        LaunchScreenComponent,
        SessionExpiredComponent,
        DateTimePipe,
        DateFormatPipe,
        DateAgoPipe,
        TimeFormatPipe,
        CurrencyFormatPipe,
        HasPropertyPipe,
        SafeHtml,
        QuickFilterComponent,
        CreateNewQuickFilterComponent,
        GenerateOrListFilterComponent,
        EmployeeTooltipComponent,
        SaveFilterComponent,
        BadgeComponent,
        GoogleMapsAutocompleteDirective,
        APILazyLoadingDirective,
        SnackBarComponent,
        LazyLoaderComponent,
        CustomerTooltipComponent,
        MenuTooltipComponent,
        DatePickerFormatDirective,
        ModuleSummaryComponent,
        JobCardComponent,
        AttachmentsListComponent,
        UpdateFieldComponent,
        DecimalValidatorDirective,
        UpdateStatusComponent,
        SendEmailSmsComponent,
        CustomersListComponent,
        RequestsListComponent,
        JobsListComponent,
        PaymentSettingsComponent,
        GalleryDetailsComponent,
        LocationPreviewComponent,
        UpdateJobStatusComponent,
        EmployeeAssignedTooltipComponent,
        UpdateScheduleComponent,
        CustomFieldsComponent,
        DialogWithMessageRemarksComponent,
        ProductDetailsModelComponent,
        ViewAllRecurringJobsComponent,
        InvoiceStatementComponent,
        AssignEmployeeTooltipComponent,
        PrintOrShareAsPDFComponent,
        UpdatePriorityComponent,
        RequestCardComponent,
        RestrictNumberDecimalDirective,
        AdvanceFilterComponent,
        AutocompleteOffDirective,
        ProjectCardComponent,
        TabsComponent,
        ProjectsListComponent,
        UpdateProjectStatusComponent,
        CreatedPopupComponent,
        PdfRendererComponent,
        PdfRendererWrapperComponent,
        DialogWithConfirmationComponent,
        ProductAssociationComponent,
        ZuperStackedToastComponent,
        JobServiceTerritoryToolTipComponent,
        ScrollRestrictDirective,
        MenuTriggerOnKeydownDirective,
        RecurrenceRuleComponent,
        JobServiceTerritoryToolTipComponent,
        ProfileSettingsComponent,
        UserSelectionComboBoxComponent,
        PhoneNumberPipe,
        PPMDetailsComponent,
        ProfileSettingsComponent,
        ProductSubscriptionAlertComponent,
        DurationPipe,
        UnreadCountPipe,
        InfinityScrollDirective,
        NumberDirective,
        TimezoneChangedPopupComponent
    ],
    providers: [
        TitleCasePipe,
        DateTimePipe,
        DatePipe,
        DateFormatPipe,
        DateAgoPipe,
        TimeFormatPipe,
        CurrencyFormatPipe,
        HasPropertyPipe,
        PhoneNumberPipe,
        DurationPipe,
        UnreadCountPipe,
        SafeHtml,
        MyCustomPaginatorIntl,
        provideHotToastConfig(),
        LocalStorageService,
        {
            provide: DateAdapter,
            useClass: MomentDateAdapter,
            deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        {
            provide: NgxMatDateAdapter,
            useClass: CustomNgxDatetimeAdapter,
            deps: [MAT_DATE_LOCALE, NGX_MAT_MOMENT_DATE_ADAPTER_OPTIONS]
        },
        { provide: NGX_MAT_DATE_FORMATS, useValue: MY_FORMATS },
        
        SnackBarService,
        {
            provide: MAT_FORM_FIELD_DEFAULT_OPTIONS, useValue: { subscriptSizing: 'dynamic', floatLabel: 'always' }
        },
        {
            provide: MAT_SELECT_CONFIG, useValue: { hideSingleSelectionIndicator: true }
        },
        NgEventBus
    ]
})
export class SharedModule {
}
